import cronstrue from 'cronstrue';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { ValueType } from 'react-select/src/types';
import { FormGroup, Label } from 'reactstrap';
import { bind } from '../Utils/Bind';
import { IFormField } from '../Utils/PrimitiveFormField';
import { Input } from './Input';
import { SelectInput } from './SelectInput';

export interface ICronInputProps {
    onChange?(): void;
    innerRef?(ref: HTMLInputElement | null): void;
    readonly field: IFormField<string>;
    readonly value?: string | number | (string | number)[] | boolean | undefined;
    readonly validation?: string;
    readonly className?: string;
    readonly disabled?: boolean;
    readonly required?: boolean;
    readonly label?: string;
}

@observer
export class CronInput extends React.Component<ICronInputProps> {
    @action
    public componentDidMount() {
        this.setDefaultScheduler();
    }

    public render() {
        const { label, field } = this.props;

        return (
            <FormGroup>
                <Label className="d-flex">
                    <strong>{label || 'Schedule'}</strong>

                    <a onClick={this.scheduleToggle} className="btn btn-link py-0">
                        {this.simpleScheduler ? 'Advanced' : 'Simple'}
                    </a>
                </Label>

                {this.simpleScheduler && (
                    <div>
                        <p>
                            <i>{this.readableForm}</i>
                        </p>

                        <SelectInput options={this.defaultOptions} field={field} required />
                    </div>
                )}

                {!this.simpleScheduler && (
                    <div>
                        <p>
                            <i>{this.readableForm}</i>
                        </p>

                        <Input type="text" field={field} required placeholder="Cron String..." />

                        <div className="d-flex align-items-start">
                            <small className="d-inline-block text-center pe-2">
                                <span>minute</span>
                            </small>

                            <small className="d-inline-block text-center px-2">
                                <span>hour</span>
                            </small>

                            <small className="d-inline-block text-center px-2">day(month)</small>

                            <small className="d-inline-block text-center px-2">
                                <span>month</span>
                            </small>

                            <small className="d-inline-block text-center px-2">day(week)</small>

                            <small>
                                <a className="btn-sm btn-link" href="https://crontab.guru/" target="_blank">
                                    Tutorial
                                </a>
                            </small>
                        </div>
                    </div>
                )}
            </FormGroup>
        );
    }

    @bind
    @action
    private scheduleToggle() {
        this.simpleScheduler = !this.simpleScheduler;
    }

    @bind
    @action
    private setDefaultScheduler() {
        if (this.defaultOptions.find(o => o.value == this.props.field.value)) {
            this.simpleScheduler = true;
        } else {
            this.simpleScheduler = false;
        }
    }

    @computed
    private get readableForm() {
        if (!this.props.field.value) return '';

        const value = this.props.field.value;
        try {
            return cronstrue.toString(value);
        } catch {
            return 'Invalid Cron String';
        }
    }

    private defaultOptions = [
        {
            label: 'Every Day at Midnight',
            value: '0 0 * * *',
        },
        {
            label: 'Every Sunday at Midnight',
            value: '0 0 * * Sun',
        },
        {
            label: 'Once a Week',
            value: '0 0 * * 0',
        },
        {
            label: 'Once a Month',
            value: '0 0 1 * *',
        },
        {
            label: 'The 1st and 15th of Every Month',
            value: '0 0 1,15 * *',
        },
    ];

    @observable private simpleScheduler = true;
}
